import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["color", "icon", "size"];
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
import React, { forwardRef, isValidElement } from 'react';
import { useTheme } from '@mui/material';
import { EzIconEzCater, EzIconFontAwesome, EzIconReactElement } from './Implementations';
var isFontAwesomeIcon = function isFontAwesomeIcon(object) {
  return Object.prototype.hasOwnProperty.call(object, 'icon');
};
var isEzcaterIcon = function isEzcaterIcon(object) {
  return typeof object === 'function';
};
var isSvgIcon = function isSvgIcon(object) {
  return isValidElement(object);
};
var EzIcon = forwardRef(function (_ref, ref) {
  var _theme$typography$ico;
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'inherit' : _ref$color,
    icon = _ref.icon,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'medium' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var theme = useTheme();
  var iconProps = _objectSpread({
    color: color,
    fontSize: size === 'inherit' ? size : (_theme$typography$ico = theme.typography.icon) === null || _theme$typography$ico === void 0 ? void 0 : _theme$typography$ico.size[size],
    ref: ref
  }, props);
  if (isFontAwesomeIcon(icon)) return React.createElement(EzIconFontAwesome, _extends({
    icon: icon
  }, iconProps));
  if (isEzcaterIcon(icon)) return React.createElement(EzIconEzCater, _extends({
    icon: icon
  }, iconProps));
  if (isSvgIcon(icon)) return React.createElement(EzIconReactElement, _extends({
    icon: icon
  }, iconProps));
  return null;
});
EzIcon.displayName = 'EzIcon';
export default EzIcon;